export { default } from "./FontAwesomeIcon";
